export const text = {
  header: "Register New User",
  button: "Register",
};
